import React, { useState } from "react";
import { observer } from "mobx-react";
import "./style.css";

import { SidebarSubjectHeader } from "../Sidebar/SidebarSubjectHeader";

type SidebarQuizzerProps = {
    children: React.ReactNode;
    subject: any;
};

const SidebarQuizzer = observer(
    ({
        children,
        subject,
    }: SidebarQuizzerProps) => {
        const [mobileProgressOpen, setMobileProgressOpen] = useState(false);

        var html = (
            <div className={"sidebar object-list-sidebar"}>
                <SidebarSubjectHeader subject={subject} />
                <button
                    className="sidebar-mobile-toggle"
                    type="button"
                    aria-expanded={mobileProgressOpen}
                    onClick={() => setMobileProgressOpen(!mobileProgressOpen)}
                >
                    {mobileProgressOpen ? "Hide progress" : "Study progress"}
                </button>
                <div className={`row sidebar-mobile-content${mobileProgressOpen ? " is-open" : ""}`}>
                    <div className="col-12">{children}</div>
                </div>
            </div>
        );

        return html;
    }
);

export default SidebarQuizzer;
